import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["alignItems", "children", "flexRef", "horizontalGap", "justify", "verticalGap"];
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { toPx } from '../utils/Styles';
import { BASE_SPACING_X, BASE_SPACING_Y, GRID_BREAKPOINT_SMALL } from 'HubStyleTokens/sizes';
import UIFlex from './UIFlex';
import refObject from '../utils/propTypes/refObject';
import { ALIGN_OPTIONS, JUSTIFY_OPTIONS } from './FlexConstants';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultHorizontalGap = parseInt(BASE_SPACING_X, 10);
const defaultVerticalGap = parseInt(BASE_SPACING_Y, 10);

/** @internal */

/** @internal */

const FlexContainer = styled(UIFlex).withConfig({
  displayName: "UIButtonWrapper__FlexContainer"
})(["margin-left:-", ";margin-top:-", ";max-width:none;width:auto;@media only screen and (max-width:", "){flex-grow:1;}&&& > *{margin-left:", ";margin-top:", ";}"], ({
  horizontalGap = defaultHorizontalGap
}) => toPx(horizontalGap), ({
  verticalGap = defaultVerticalGap
}) => toPx(verticalGap), GRID_BREAKPOINT_SMALL, ({
  horizontalGap = defaultHorizontalGap
}) => toPx(horizontalGap), ({
  verticalGap = defaultVerticalGap
}) => toPx(verticalGap));
const UIButtonWrapper = props => {
  const {
      alignItems = 'center',
      children,
      flexRef,
      horizontalGap = defaultHorizontalGap,
      justify,
      verticalGap = defaultVerticalGap
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx("div", Object.assign({}, rest, {
    children: /*#__PURE__*/_jsx(FlexContainer, {
      align: alignItems,
      horizontalGap: horizontalGap,
      justify: justify,
      ref: flexRef,
      verticalGap: verticalGap,
      wrap: "wrap",
      children: children
    })
  }));
};
UIButtonWrapper.propTypes = {
  alignItems: PropTypes.oneOf(Object.keys(ALIGN_OPTIONS)),
  children: PropTypes.node,
  flexRef: refObject,
  justify: PropTypes.oneOf(Object.keys(JUSTIFY_OPTIONS)),
  horizontalGap: PropTypes.number,
  verticalGap: PropTypes.number
};
UIButtonWrapper.displayName = 'UIButtonWrapper';
export default UIButtonWrapper;